import {
    FETCH_MENU,
    FETCH_MENU_SUCCEED,
    LOGIN,
    LOGOUT,
    SET_IS_TRANSITIONING,
    TRIGGER_LOGIN_MODAL
} from 'reducer/constants';

type ActionReturnType = {
    type: string;
};

export function fetchMenuAction(): ActionReturnType {
    return {
        type: FETCH_MENU
    };
}

type FetchMenuSucceedActionReturnType = {
    menu: MenuItem[];
} & ActionReturnType;

export function fetchMenuSucceedAction(menu: MenuItem[]): FetchMenuSucceedActionReturnType {
    return {
        type: FETCH_MENU_SUCCEED,
        menu
    };
}

type TriggerModalReturnType = {
    visible: boolean;
} & ActionReturnType;

export function openLoginModal(): TriggerModalReturnType {
    return { type: TRIGGER_LOGIN_MODAL, visible: true };
}

export function closeLoginModal(): TriggerModalReturnType {
    return { type: TRIGGER_LOGIN_MODAL, visible: false };
}

type LoginReturnType = {
    user: AuthUser;
} & ActionReturnType;

export function login(user: AuthUser): LoginReturnType {
    return {
        type: LOGIN,
        user
    };
}

type TransitioningReturnType = {
    state: boolean;
} & ActionReturnType;

export function setIsTransitioning(state: boolean): TransitioningReturnType {
    return {
        type: SET_IS_TRANSITIONING,
        state
    };
}

export function logout(): ActionReturnType {
    return {
        type: LOGOUT
    };
}
